import { EMPTY_STATE_TYPE } from '../enum/empty-state';

export const EMPTY_STATE_IMAGE = new Map<EMPTY_STATE_TYPE, string>()
    .set(EMPTY_STATE_TYPE.EMPTY_COLLECTION, '/assets/img/empty-states/empty-collection.svg')
    .set(EMPTY_STATE_TYPE.EMPTY_DASHBOARD, '/assets/img/empty-states/empty-dashboard.svg')
    .set(EMPTY_STATE_TYPE.EMPTY_SEARCH, '/assets/img/empty-states/empty-search.svg')
    .set(EMPTY_STATE_TYPE.ERROR, '/assets/img/empty-states/error.svg')
    .set(EMPTY_STATE_TYPE.NOT_CONFIGURED, '/assets/img/empty-states/not-configured.svg');
